module.exports = __webpack_public_path__ + "img/payment_2x.d3397aaf.png";